import React, { useState } from 'react';
import { useEffect } from 'react';
import {
  Typography,
  CardContent,
  CardActions,
  Card,
  Box,
  Avatar,
} from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import { Applicant } from 'types';
import { useAuth } from 'app/ProviderAuth';
import { stringAvatar } from 'helper/conversation';
const useStyles = makeStyles(() =>
createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '800px',
    height:'auto',
    top: '104px',
    left: '320px',
    gap: '32px',
    padding: '32px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 6px 0 rgb(0 0 0 / 15%)',
    borderRadius: '16px',
    margin: '32px',
    '@media (max-width: 768px)': {
      width: '343px',
      top: '88px',
      left: '16px',
      gap: '24px',
      paddingTop: '20px',
      paddingRight: '24px',
      paddingBottom: '20px',
      paddingLeft: '24px',
    }
  },
  IconLink: {
    display: 'flex',
    margin: 0,
    padding: 0,
    textDecoration: 'none'
  },
  Iconbg: {
    backgroundColor: '#E5E8EE',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  IconBox:{
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 'auto',
    '@media (max-width: 768px)': {
      width: 'auto',
      gap: '8px',
    }
  },
  CompanyBox: {
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    height: 'auto',
    maxwidth: '160px',
    maxheight: '256px',
    gap: '16px',
    alignItems: 'center',
    '@media (max-width: 768px)': {
    width: '100%',
    height: 'auto',
    gap: '12px',
    }
  },
  CompanyName:{
    fontFamily: 'Noto Sans TC',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '27.5px',
    textAlign: 'center',
    maxwidth: '122px',
    maxheight: '28px',
    whiteSpace: 'nowrap',
  },
  ProfileInfo:{
    display: 'flex',
    flexDirection: 'column',
    width:'100%',
    height: 'auto',
    gap: '24px',
    '@media (max-width: 768px)': {
    gap: '16px',
    }
  },
  InfoChip:{
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    width: '100%',
    height: 'auto',
    maxHeight: '28px',
  },
  InfotextSm:{
    fontFamily:'Noto Sans TC', fontSize:'16px', fontWeight:400, lineHeight:'22.4px', color:'#4D5461',
  },
  InfotextL:{
    fontFamily:'Noto Sans TC', fontSize:'16px', fontWeight:500, lineHeight:'22.4px', color:'#141921'
  },
  CustomButton:{
    width:'100%',
    maxWidth:'362px',
    height:'48px',
    borderRadius:'100px',
    padding:'10px,64px,10px,64px',
    backgroundColor:'#E5E8EE',
    fontFamily:'Noto Sans TC',
    fontSize:'20px',
    fontWeight:500,
    lineHeight:'28px',
    color:'#002761',
    '@media (max-width: 768px)': {
    maxWidth: '295px',
    fontSize:'clamp(12px, 20px, 20px)',
    whiteSpace: 'nowrap',
    }
  },
  CustomChip:{
    width:'auto',
    maxwidth:'133px',
    height:'28px',
    borderRadius:'8px',
    padding:'12px',
    backgroundColor:'#C6F5D5',
    '& .MuiChip-label':{
      fontFamily:'Noto Sans TC',
      fontSize:'14px',
      fontWeight:400,
      lineHeight:'19.6px',
      color:'#000000DE',
      whiteSpace:'nowrap',
      padding:'0px',
      textAlign:'center',
    }
  }
})
)
;

interface ProfileCardProps {
  applicant: Applicant | undefined;
  isReferrerActive: boolean;
  navigateTo:(id:string) => void;
}

export const ProfileCard :React.FC <ProfileCardProps> = ({applicant, isReferrerActive, navigateTo}) => {
  const { user } = useAuth();
  const classes = useStyles();
  const [userDocID, setUserDocID] = useState('');
  useEffect(() => {
    if (user) {
      const fetchData = async function () {
        setUserDocID(user.uid);
      };
      fetchData();
    }
  }, [user]);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: 'auto',
      }}
    >
      <Card className={classes.root}>
        <CardContent sx={{width:'100%', height:'auto', gap:'32px', display:'flex', flexDirection:'row', '@media (max-width: 768px)':{display:'flex', flexDirection:'column'}}}>
          <Box className={classes.CompanyBox}>
            <Avatar
              alt="Remy Sharp"
              src={applicant?.profilePicture || ''}
              sx={{ width: 160, height: 160, fontSize: 64, fontWeight: 'bold'}}
            >
             {stringAvatar(`${applicant?.preferredName} ${applicant?.lastName}`).children}
            </Avatar>
            <Typography className={classes.CompanyName}>{applicant?.preferredName} {applicant?.lastName}</Typography>
            <Box className={classes.IconBox}>
              <Box className={classes.Iconbg}>
                <Link to={applicant?.website || ''} target='blank' className={classes.IconLink}>
                  <LanguageOutlinedIcon sx={{color:'black', height:'24px', width: '24px'}}/>
                </Link>
              </Box>
              <Box className={classes.Iconbg}>
                <Link to={applicant?.email  ||''} target='blank' className={classes.IconLink}>
                  <EmailOutlinedIcon sx={{color:'black', height:'24px', width: '24px'}}/>
                </Link>
              </Box>
              <Box className={classes.Iconbg}>
                <Link to={applicant?.linkedIn ||''} className={classes.IconLink} target="_blank" rel="noopener noreferrer">
                  <img src="/ant-design_linkedin-outlined.png" alt="LinkedInIcon" style={{height:'24px', width: '24px'}} />
                </Link>
              </Box>
            </Box>
          </Box>
          <Box className={classes.ProfileInfo}>
            <Box className={classes.InfoChip}>
            {isReferrerActive && (
            <Chip className={classes.CustomChip} label="NEX Work 推薦人" />
          )}
            </Box>
            <Box sx={{width:'100%', minheight:'48px', gap:'24px',display:'flex', flexDirection:'row', '@media (max-width: 768px)':{display:'flex', flexDirection:'column', gap: '16px'}}}>
              <Box sx={{width:'160px', height: 'auto', maxheight:'48px', gap:'4px','@media (max-width: 768px)':{width: '295px'}}}>
                <Typography className={classes.InfotextL}>
                  所在國家
                </Typography>
                <Typography className={classes.InfotextSm}>
                  {applicant?.countryOfResidence}
                </Typography>
              </Box>
              <Box sx={{width:'160px', height: 'auto', maxheight:'48px', gap:'4px','@media (max-width: 768px)':{width: '295px'}}}>
                <Typography className={classes.InfotextL}>
                  職業
                </Typography>
                <Typography className={classes.InfotextSm}>
                  {`${applicant?.occupation} @ ${applicant?.schoolOrCompany}`}
                </Typography>
              </Box>
            </Box>
            <Box sx={{width:'100%', height:'auto', gap:'4px', display:'flex', flexDirection:'column', '@media (max-width: 768px)':{maxwidth: '295px'}}}>
              <Typography className={classes.InfotextL}>
                Bio
              </Typography>
              <Typography className={classes.InfotextSm}>
                {applicant?.biography}
              </Typography>
            </Box>
          </Box>

        </CardContent>
        <CardActions sx={{width:'100%', maxWidth:'736px', height: 'auto', maxheight:'48px', gap:'12px', '@media (max-width: 768px)': {maxWidth: '295px', maxHeight: '104px',gap: '8px', display:'flex', flexDirection: 'column'}}}>
            <Button className={classes.CustomButton}>
              預約對談(coming soon)
            </Button>
            <Button
            className={classes.CustomButton}
            disabled={!isReferrerActive}
            onClick={() => navigateTo(userDocID)}
            >
              內推資訊
            </Button>

        </CardActions>
      </Card>
    </Box>
  );
};
